import h, { getCountry } from "../helpers/common";
import user from "../helpers/user";
import { staticDeviceInfo } from "../hooks/useCSAI";
import type { IProfileData } from "@intigral/types";
import { playerSSAIManager } from "./SSAI";

interface Asset {
    guid?: string;
    genre?: Array<string>;
    categoryType?: Array<string>;
    language: Array<string> | string;
    ratings: Array<{
        scheme: string;
        rating: string;
        subRatings: Array<any>;
    }>;

    /** Exist only for Linear assets */
    channel?: {
        adEnabled?: boolean;
        channelTitle?: string;
        guid?: string;
        category?: Array<string>;
    };

    /** Exist only for VOD assets */
    adEnabled?: boolean;
}

export function generateSupplyTags(asset: Asset) {
    const { adTagParams } = h.getAppConfig().avodConfigs;
    const profileInfo: IProfileData = user.getProfile();
    return {
        w: window.innerWidth.toString(),
        h: window.innerHeight.toString(),
        cb: Date.now().toString(),
        url: adTagParams.domain,
        app_bundle: adTagParams.appBundle,
        app_name: adTagParams.appName,
        country: getCountry() as string,
        did: user.getUserDeviceId() as string,
        ifa_type: adTagParams.ifaType,
        content_id: asset?.guid ?? asset?.channel?.guid ?? '',
        content_genre: (asset?.genre || asset?.channel?.category || []).join(','),
        language: h.getLang() as string,
        pod_max_dur: (adTagParams.pod_max_dur || 90).toString(),
        coppa: profileInfo?.kidsMode ? '1' : '0',
        rating: asset?.ratings?.[0]?.rating || profileInfo?.newParentalControl || profileInfo?.parentalControl,
        ip: h.getUserIP() as string,
        ...staticDeviceInfo,
        dnt: (adTagParams.dnt || 0).toString(),
        lmt: (adTagParams.lmt || 0).toString(),
    };

}

export function generateSupplyTagsForSSAI() {
    const details = playerSSAIManager.mpxDetails?.entries?.[0];
    return {
        ...generateSupplyTags(details as any),
        content_genre: details?.tags?.filter(tag => tag.scheme === "Genre")?.map(tag => tag.title).join(",") || "",
        rating: details?.ratings?.[0]?.rating || ""
    }
}